import { useState } from "react";

type FaqAccordionProps = {
  items: { q: string; a: string }[];
};

export default function FaqAccordion({ items }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200/70 bg-background-100">
      {items.map((item, i) => {
        const open = openIndex === i;
        return (
          <div key={item.q}>
            <button
              type="button"
              onClick={() => setOpenIndex(open ? null : i)}
              className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition hover:bg-background-200/40 md:px-6 md:py-5"
              aria-expanded={open}
            >
              <span className="font-heading text-sm font-bold text-foreground-900 md:text-base">
                {item.q}
              </span>
              <span
                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-background-300 text-foreground-600 transition ${
                  open ? "rotate-180 border-primary-500 text-primary-500" : ""
                }`}
              >
                <i className="ri-arrow-down-s-line"></i>
              </span>
            </button>
            {open && (
              <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-500 md:px-6 md:pb-6">
                {item.a}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
}